import React, { useCallback } from "react";

import { useNavigate } from "@reach/router";
import { toLocalStorage } from "kanopi-components/utils/browser";
import { setBearer } from "kw/api";
import { useGlobal } from "kanopi-components/useGlobal";
import { userFields } from "kw/api/fragments";
import { useAPI } from "kw/api/useAPI";
import { useUser } from "kw/auth/useUser";

export function UserHijackingReleasePage() {
  const navigate = useNavigate();
  const [, setAuth] = useGlobal("auth");
  const [hijack] = useGlobal("hijack");
  const { mutation } = useAPI();
  const user = useUser();
  const releaseToUrl = hijack?.releaseToUrl ?? "/admin";
  const releaseUser = useCallback(() => {
    mutation(
      {
        releaseUser: {
          token: true,
          user: userFields,
        },
      },
      async (response) => {
        if (response?.releaseUser?.token) {
          setBearer(response.releaseUser.token);
          toLocalStorage("auth", response.releaseUser);
          await setAuth(response.releaseUser);
          navigate(`${releaseToUrl}`);
        }
      }
    );
  }, []);

  React.useEffect(() => {
    // FIXME: This is a hack to prevent an anonymous user from being released
    // ClickUp task: https://app.clickup.com/t/2703166/DEV-3956
    // For some reasons, unauthorized users (e.g. logged out user) can release
    // a user and get logged to the admin page
    // Use this check to ensure that only hijacked user can be released
    if (user?.isHijacked) {
      releaseUser();
    } else {
      navigate("/login");
    }
  }, []);

  return <></>;
}
